import {
  Box,
  Button,
  Flex,
  Grid,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useBreakpointValue,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import CommonModal from "components/common/CommonModal/CommonModal";
import CustomDateRangeMobile from "components/common/CustomDateRangeMobile/CustomDateRangeMobile";
import CustomDateRangePicker from "components/common/CustomDateRangePicker/CustomDateRangePicker";
import { Paginationlimit } from "components/common/functions/variable";
import Pagination from "components/common/Pagination/Pagination";
import TableLoader from "components/common/TableLoader/TableLoader";
import { useContext, useEffect, useState } from "react";
import { HiOutlineFilter, HiOutlineRefresh } from "react-icons/hi";
import { RiFileExcel2Line } from "react-icons/ri";
import { appRequest } from "routes";
import { formatDateTime } from "utils/dateUtils/dateUtils";
import * as XLSX from "xlsx";
import CreateIssue from "../../common/CreateIssue/CreateIssue";
import CustomSelect from "../../common/CustomSelect/CustomSelect";
import { useHasPermission } from "../../common/PermissionsFunction/permissiosnFunction";
import OrderCard from "./OrderCardView/OrderCard";
import { formatDateYYYYMMDD } from "App/DMRC/FortamDate";
import SdkOrderDetails from "../../Dashboards/OrderDashboard/SdkOrderDetails";

const OrderTable = () => {
  const [isDrawerOpen, setIsSrawerOpen] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [data, setData] = useState<any[]>([]);
  const [orderData, setOrderData] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [filterStatus, setFilterStatus] = useState<any>("");
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [bapIdFilter, setBapIdFilter] = useState<any>("");
  const [stationFilters, setStationFilters] = useState<any>("");
  const [customerDetails, setCustomerDetails] = useState<any>({});
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [orderIds, setOrderIds] = useState<any>();
  const { toastNotify } = useContext(AppContext);
  const [orderIdOptions, setOrderIdOptions] = useState<any[]>([]);
  const initialDateRange = {
    startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    endDate: new Date(),
    key: "selection",
  };

  const [dateRange, setDateRange] = useState<any>(initialDateRange);
  const { startDate, endDate } = dateRange;
  const drawerWidth = useBreakpointValue({
    base: "100vw",
    md: "80vw",
    lg: "55vw",
  });
  const [cities, setCities] = useState<any>([]);
  const [cityFilter, setCityFilter] = useState<any>("");
  const [cityCode, setCityCode] = useState<any>("");
  const [cityName, setCityName] = useState<any>("");
  const [providers, setProviders] = useState<any>([]);
  const isMobileView = useBreakpointValue({ base: true, md: false });
  const [stations, setStations] = useState<any[]>([]);

  const handleOrderDetails = (data: any) => {
    setOrderData(data);
    setIsSrawerOpen(true);
  };

  const handleFilterChange = (e: any) => {
    if (e && e.value) {
      setBapIdFilter(e.value);
    } else {
      setBapIdFilter(null);
    }
  };

  const getCities = async () => {
    try {
      setLoading(true);
      const response: any = await appRequest("metro", "allCities", {});
      if (response.status === "success") {
        setCities(response?.cities || []);
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const formattedStartDate = formatDateYYYYMMDD(startDate);
  const formattedEndDate = formatDateYYYYMMDD(endDate);

  const getOrders = async (currentP?: number, isDownload?: boolean) => {
    try {
      setLoading(true);
      let page = currentP ? currentP : currentPage;
      let limit = Paginationlimit;
      let status = filterStatus ? filterStatus : "";
      let providerName = bapIdFilter ? bapIdFilter : "";
      let fromStation = stationFilters ? stationFilters : "";
      let orderIdSearch = orderIds === undefined ? "" : orderIds;
      const id = cityFilter;
      isDownload = isDownload || false;

      const request: any = {
        limit,
        page,
        status,
        providerName,
        fromStation,
        id,
        isDownload,
        cityCode,
      };
      if (orderIdSearch.length === 0) {
        request.startDate = formattedStartDate;
        request.endDate = formattedEndDate;
      }
      if (orderIdSearch.length > 0) {
        request.orderIdSearch = orderIdSearch;
      }

      const response: any = await appRequest("metro", "orders", request);

      if (response.status === "success") {
        setData(response?.orders || []);
        setTotalPages(response?.totalPages || 0);

        if (isDownload) {
          exportToExcel(response?.orders || []);
        }
      }
    } catch (err: any) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const getProviders = async () => {
    try {
      const id = cityFilter;
      const response: any = await appRequest("metro", "allProvidersForFilter", {
        id,
        cityCode,
      });
      if (response.status === "success") {
        setProviders(response.allProviders || []);
      }
    } catch (error: any) {
      console.error("Error fetching providers:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStations = async () => {
    try {
      const id = cityFilter;
      const response: any = await appRequest("metro", "allStationsForFilter", {
        id,
        cityCode,
      });
      if (response.status === "success") {
        setStations(response.stations || []);
      }
    } catch (error: any) {
      console.log("Error fetching stations:", error);
    }
  };

  // Export now mirrors the transaction-shaped payload (same shape SdkOrderTable exports)
  const exportToExcel = async (data: any) => {
    if (!data || data.length === 0) {
      console.error("No data available for export");
      return;
    }

    const filteredData = data.map((txn: any) => ({
      Date: formatDateTime(txn?.createdAt) || "N/A",
      TransactionId: txn?._id || "N/A",
      OrderTransactionIds:
        [...new Set(txn?.orders?.map((o: any) => o?.transaction_id))].join(", ") ||
        "N/A",
      UserName: txn?.user?.name || txn?.billingDetails?.name || "N/A",
      UserNumber: txn?.user?.moNumber || txn?.billingDetails?.phone || "N/A",
      StartStation: txn?.startStation || "N/A",
      DestinationStation: txn?.destinationStation || "N/A",
      Providers:
        [...new Set(txn?.orders?.map((o: any) => o.providerName))].join(", ") ||
        "N/A",
      NumberOfTickets: txn?.ticketCount || 0,
      Price_Rs: txn?.totalPrice || 0,
      Status: txn?.status || "Unknown",
    }));

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    const filename = `orders_report_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, filename);
  };

  const getOrderIds = async () => {
    try {
      const id = cityFilter;
      const response: any = await appRequest("metro", "allOrderIds", { id, cityCode });
      if (response.status === "success") {
        setOrderIdOptions(response?.orderIds || []);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const orderIdOption = orderIdOptions?.map((item: any) => ({
    value: item,
    label: item,
  }));

  const orderIdChange = (OrderIdOptions: any) => {
    const selectedIds = OrderIdOptions
      ? OrderIdOptions.map((option: any) => option.value)
      : [];
    setCurrentPage(1);
    setOrderIds(selectedIds);
  };

  useEffect(() => {
    getOrders();
  }, [
    currentPage,
    filterStatus,
    bapIdFilter,
    endDate,
    stationFilters,
    orderIds,
    cityFilter,
    cityCode,
  ]);

  useEffect(() => {
    getProviders();
    getStations();
    getOrderIds();
  }, [cityFilter, cityCode]);

  useEffect(() => {
    getCities();
    getOrderIds();
  }, []);

  const cityNames = cities.map((city: any) => ({
    value: city?._id,
    label: city?.name,
    cityCode: city?.cityCode,
  }));

  const handleCityFilterChange = (e: any) => {
    if (e && e.value) {
      const selectedCity = {
        id: e.value,
        cityCode: e.cityCode,
        name: e.label,
      };
      setCityFilter(selectedCity.id);
      setCityCode(selectedCity.cityCode);
      setCityName(selectedCity.name);
      localStorage.setItem("selectedCity", JSON.stringify(selectedCity));
    } else {
      setCityFilter(null);
      localStorage.removeItem("selectedCity");
    }
  };

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected + 1);
  };

  // Adapted to the transaction shape: pull the first order's transaction_id
  // and the billing/user info that now lives on the txn itself.
  const handleTransactionId = (txn: any) => {
    setTransactionId(txn?.orders?.[0]?.transaction_id || txn?._id);
    setCustomerDetails(txn?.billingDetails || txn?.user);
    onOpen();
  };

  const handleCancel = async () => {
    setLoading(true);
    try {
      // selectedValues holds txn._id's; resolve them to the underlying
      // order transaction_id's (a txn can wrap multiple orders).
      const selectedTxns = data.filter((txn) => selectedValues.includes(txn._id));
      const transaction_id = selectedTxns.flatMap(
        (txn: any) => txn?.orders?.map((o: any) => o?.transaction_id) || []
      );
      const domain = "ONDC:TRV11";
      const version = "2.0.0";

      const values = {
        context: {
          transaction_id,
          domain,
          version,
        },
        message: {
          service: {
            code: "MERCHANT-SIDE-CANCELLATION",
            name: "merchant side cancelltaion",
          },
          cancellation_reason_id: "0",
        },
      };
      const uri = `${process.env.REACT_APP_SELLER_CLIENT_URL || ""}/dmrc/client/merchant-side-cancellation`;
      const response: any = await appRequest("seller", "issueActions", {
        values,
        uri,
      });
      setLoading(true);
      if (response?.data?.message?.ack?.status === "ACK") {
        toastNotify({
          title: "Success",
          message: "Merchant side cancellation successfully sent",
          type: "success",
        });
      }
    } catch (error: any) {
      console.log("error", error.message);
      toastNotify({
        title: "Error",
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
      await new Promise((r: any) => setTimeout(r, 2000));
      await getOrders();
      setLoading(false);
      setSelectedValues([]);
      setOpenCancelModal(false);
    }
  };

  const handleStartDateChange = (startDate: Date) => {
    setDateRange((prevDateRange: any) => ({
      ...prevDateRange,
      startDate: new Date(startDate),
    }));
  };

  const handleEndDateChange = (endDate: Date) => {
    setDateRange((prevDateRange: any) => ({
      ...prevDateRange,
      endDate: new Date(endDate),
    }));
  };

  const handleDateChange = (item: any) => {
    const newStartDate = item.selection.startDate.toISOString();
    const newEndDate = item.selection.endDate.toISOString();
    handleStartDateChange(newStartDate);
    handleEndDateChange(newEndDate);
  };

  const stationOptions = stations.map((station: any) => ({
    label: station?.station_name,
  }));

  const handleStationChange = (e: any) => {
    if (e && e.label) {
      setStationFilters(e.label);
    } else {
      setStationFilters(null);
    }
  };

  const handleStatusChange = (e: any) => {
    if (e && e.value) {
      setFilterStatus(e.value);
    } else {
      setFilterStatus(null);
    }
  };

  const filterStatusOptions = [
    { value: "CANCELLED", label: "Cancelled" },
    { value: "ACTIVE", label: "Active" },
    { value: "COMPLETED", label: "Completed" },
    { value: "EXPIRED", label: "Expired" },
  ];

  const handleRefreshAllData = () => {
    setDateRange(initialDateRange);
    setStationFilters("");
    setFilterStatus("");
    setBapIdFilter("");
    setOrderIds([]);
    setSelectedValues([]);
  };

  const canCancelOrder = useHasPermission("canCancelOrders");
  const canRaiseIssue = useHasPermission("canRaiseIssue");

  const providerNames = providers.map((provider: any) => ({
    value: provider?.providerName,
    label: provider?.providerName,
  }));

  useEffect(() => {
    const storedCity = JSON.parse(
      localStorage.getItem("selectedCity") || "null"
    );
    if (storedCity) {
      setCityFilter(storedCity.id);
      setCityCode(storedCity.cityCode);
      setCityName(storedCity.name);
    } else {
      setCityFilter(null);
      setCityName(null);
    }
  }, []);

  return (
    <Box
      p={5}
      rounded={"lg"}
      bg={"white"}
      shadow={"rgb(0 0 0 / 20%) 0px 0px 11px"}
    >
      <Flex
        justify={"space-between"}
        mb={2}
        direction={{ base: "column", md: "row" }}
      >
        <Text fontWeight={700} fontSize={"xl"} color={"teal.400"} mb={2}>
          All Orders
        </Text>

        <Flex gap={2} direction={{ base: "column", md: "row" }}>
          <Flex align="center" gap={2} mb={{ base: 2, lg: 0 }}>
            {cityFilter ? (
              <Text fontWeight="bold" fontSize="md" color="teal.600">
                City:{cityName}
              </Text>
            ) : (
              <Text fontWeight="bold" fontSize="md" color="gray.500">
                No City Selected
              </Text>
            )}
          </Flex>
          <Box display={{ base: "none", lg: "block" }}>
            <CustomDateRangePicker
              dateFrom={dateRange.startDate && new Date(dateRange.startDate)}
              dateTo={dateRange.endDate && new Date(dateRange.endDate)}
              onStartDateChange={handleStartDateChange}
              onEndDateChange={handleEndDateChange}
              months={2}
            />
          </Box>
          <Box display={{ base: "block", lg: "none" }}>
            <CustomDateRangeMobile
              range={[dateRange]}
              onChange={handleDateChange}
            />
          </Box>

          <Grid templateColumns="1fr 1fr" gap={2} alignItems={"center"}>
            <Tooltip label="Refresh" hasArrow>
              <IconButton
                aria-label="Refresh"
                icon={<HiOutlineRefresh />}
                colorScheme="teal"
                variant="outline"
                borderWidth={2}
                _hover={{ bg: "teal.100" }}
                onClick={handleRefreshAllData}
                size={{ base: "sm", md: "md" }}
              />
            </Tooltip>
            <Popover>
              <PopoverTrigger>
                <IconButton
                  aria-label="Filter"
                  colorScheme="teal"
                  icon={<HiOutlineFilter />}
                  size={{ base: "sm", md: "md" }}
                />
              </PopoverTrigger>
              <Portal>
                <PopoverContent shadow={"lg"} borderWidth={2}>
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverBody p={5}>
                    <VStack spacing={6} mt={2}>
                      <CustomSelect
                        options={cityNames}
                        label={"Filter By City"}
                        onChange={handleCityFilterChange}
                      />
                      <CustomSelect
                        options={orderIdOption}
                        label={"Order Ids"}
                        isMulti={true}
                        onChange={orderIdChange}
                      />
                      {/* <CustomSelect
                        options={stationOptions}
                        label={"From Station"}
                        onChange={handleStationChange}
                      />
                      <CustomSelect
                        options={providerNames}
                        label={"Providers"}
                        onChange={handleFilterChange}
                      /> */}
                      <CustomSelect
                        options={filterStatusOptions}
                        label={"Filter By Status"}
                        onChange={handleStatusChange}
                      />
                      {/* <Button
                        w={"100%"}
                        colorScheme="teal"
                        variant={"outline"}
                        onClick={() => getOrders(undefined, true)}
                        leftIcon={
                          <RiFileExcel2Line
                            fontSize={"20px"}
                            color="green.400"
                          />
                        }
                      >
                        Download Excel
                      </Button> */}
                    </VStack>
                  </PopoverBody>
                </PopoverContent>
              </Portal>
            </Popover>
          </Grid>
        </Flex>
      </Flex>
      {cityFilter ? (
        <>
          {isMobileView ? (
            <>
              <OrderCard
                data={data}
                selectedValues={selectedValues}
                canRaiseIssue={canRaiseIssue}
                canCancelOrder={canCancelOrder}
                setOpenCancelModal={setOpenCancelModal}
                setSelectedValues={setSelectedValues}
                handleTransactionId={handleTransactionId}
              />
            </>
          ) : (
            <>
              <TableContainer className="customScrollBar" pb={2}>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Transaction ID</Th>
                      <Th>Order Transaction ID</Th>
                      <Th>User Name</Th>
                      <Th>User Number</Th>
                      <Th>Start</Th>
                      <Th>Destination</Th>
                      <Th>Providers</Th>
                      <Th textAlign={"center"}>Tickets</Th>
                      <Th textAlign={"end"}>Total Fare</Th>
                      <Th>Date</Th>
                      <Th>Status</Th>
                      {canRaiseIssue && <Th></Th>}
                      {canCancelOrder && <Th></Th>}
                    </Tr>
                  </Thead>
                  <TableLoader
                    noDataText="No Orders Available"
                    show={data?.length}
                    loader={loading}
                  >
                    <Tbody>
                      {data?.map((txn) => {
                        const providerList =
                          txn?.orders?.map((o: any) => o.providerName) || [];
                        const providerLabel =
                          [...new Set(providerList)].length > 1
                            ? "Multiple"
                            : providerList[0] || "N/A";

                        return (
                          <Tr key={txn._id} _hover={{ bg: "gray.100" }}>
                            <Td>
                              <Flex gap={2} align={"flex-end"}>
                                <Tooltip label={txn?._id} hasArrow>
                                  <Text
                                    color={"blue.500"}
                                    fontWeight={500}
                                    _hover={{ transform: "scale(1.05)" }}
                                    transition={"0.3s ease-in-out"}
                                    cursor={"pointer"}
                                    isTruncated
                                    maxW={"12rem"}
                                    onClick={() => handleOrderDetails(txn)}
                                  >
                                    {txn?._id}
                                  </Text>
                                </Tooltip>
                              </Flex>
                            </Td>

                            <Td>
                              {txn?.orders?.length ? (
                                <Flex direction="column" gap={1}>
                                  {txn.orders
                                    .map((order: any) => order?.transaction_id)
                                    .filter(Boolean)
                                    .map((id: any, i: number) => (
                                      <Tooltip key={i} label={id} hasArrow>
                                        <Text
                                          isTruncated
                                          maxW="12rem"
                                          whiteSpace="nowrap"
                                          overflow="hidden"
                                          textOverflow="ellipsis"
                                        >
                                          {id}
                                        </Text>
                                      </Tooltip>
                                    ))}
                                </Flex>
                              ) : (
                                "N/A"
                              )}
                            </Td>

                            <Td>{txn?.user?.name || txn?.billingDetails?.name || "N/A"}</Td>
                            <Td>{txn?.user?.moNumber || txn?.billingDetails?.phone || "N/A"}</Td>
                            <Td>{txn?.startStation || "N/A"}</Td>
                            <Td>{txn?.destinationStation || "N/A"}</Td>
                            <Td isTruncated maxW={"10rem"}>{providerLabel}</Td>
                            <Td textAlign={"center"}>{txn?.ticketCount || 0}</Td>
                            <Td textAlign={"end"}>₹ {txn?.totalPrice || 0}</Td>
                            <Td>{formatDateTime(txn?.createdAt, "DD-MM-YYYY")}</Td>
                            <Td>
                              <Tag
                                size={"sm"}
                                colorScheme={
                                  txn?.status === "SUCCESSFUL"
                                    ? "green"
                                    : txn?.status === "REFUNDED"
                                      ? "green"
                                      : txn?.status === "PAYMENT_VERIFIED"
                                        ? "green"
                                        : txn?.status === "PAYMENT_FAILED"
                                          ? "red"
                                          : txn?.status === "CANCELLED"
                                            ? "red"
                                            : txn?.status === "PAYMENT_INITIATED"
                                              ? "orange"
                                              : txn?.status === "CANCEL_INITIATED"
                                                ? "orange"
                                                : "blue"
                                }
                              >
                                {txn?.status}
                              </Tag>
                            </Td>
                            {canRaiseIssue && (
                              <Td
                                onClick={() => handleTransactionId(txn)}
                                fontWeight={500}
                                color={"teal.300"}
                                cursor={"pointer"}
                                _hover={{ color: "teal.500" }}
                              >
                                Issue
                              </Td>
                            )}
                            {canCancelOrder && (
                              <Td>
                                {txn?.status === "ACTIVE" && (
                                  <Button
                                    variant={"outline"}
                                    colorScheme="red"
                                    size={"xs"}
                                    isDisabled={
                                      selectedValues.length > 0 ? true : false
                                    }
                                    onClick={() => {
                                      setOpenCancelModal(true);
                                      setSelectedValues((prevSelectedValues) => [
                                        ...prevSelectedValues,
                                        txn?._id,
                                      ]);
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                )}
                              </Td>
                            )}
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </TableLoader>
                </Table>
              </TableContainer>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            </>
          )}
        </>
      ) : (
        <Box p={4}>
          <Text fontSize="lg" color="red.700" textAlign="center">
            No city is selected. Please select a city.
          </Text>
        </Box>
      )}

      <CommonModal
        isOpen={isDrawerOpen}
        onClose={() => setIsSrawerOpen(false)}
        animate={true}
        width={drawerWidth}
        body={
          <Box>{orderData && <SdkOrderDetails data={orderData} />}</Box>
        }
      />
      <CommonModal
        isOpen={openCancelModal}
        onClose={() => {
          setOpenCancelModal(false);
          setSelectedValues([]);
        }}
        isCentered={true}
        size="md"
        closeOnOverlayClick={false}
        body={
          <Box p={{ base: 0, md: 4 }} mt={{ base: 2, md: 0 }}>
            <Text
              fontSize="xl"
              fontWeight="bold"
              textAlign="center"
              mb={{ base: 2, md: 4 }}
            >
              Confirm Ticket Cancellation
            </Text>
            <Text fontSize="md" textAlign="center" color="gray.600">
              Are you sure you want to cancel this ticket? This action cannot be
              undone.
            </Text>
          </Box>
        }
        footer={
          <Flex
            justify="center"
            gap={{ base: 2, md: 4 }}
            w={"full"}
            borderColor="gray.200"
          >
            <Button
              onClick={() => {
                setOpenCancelModal(false);
                setSelectedValues([]);
              }}
              colorScheme="red"
              size={{ base: "sm", md: "md" }}
              variant="outline"
              _hover={{ bg: "red.100" }}
            >
              No, Keep Ticket
            </Button>
            <Button
              onClick={() => handleCancel()}
              colorScheme="teal"
              size={{ base: "sm", md: "md" }}
              _hover={{ bg: "teal.400" }}
              isLoading={loading}
            >
              Yes, Cancel Ticket
            </Button>
          </Flex>
        }
      />

      <CreateIssue
        isOpen={isOpen}
        onClose={onClose}
        transaction_id={transactionId}
        customerDetails={customerDetails}
      />
    </Box>
  );
};

export default OrderTable;